"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SubscriptionEcommerceProduct {
    constructor(brand, category, id, name, price, quantity, list, position, dimension3, dimension5, dimension6, dimension7, dimension8, dimension9, dimension10, dimension11, dimension12) {
        this.brand = brand;
        this.category = category;
        this.id = id;
        this.name = name;
        this.price = price;
        this.quantity = quantity;
        this.list = list;
        this.position = position;
        this.dimension3 = dimension3;
        this.dimension5 = dimension5;
        this.dimension6 = dimension6;
        this.dimension7 = dimension7;
        this.dimension8 = dimension8;
        this.dimension9 = dimension9;
        this.dimension10 = dimension10;
        this.dimension11 = dimension11;
        this.dimension12 = dimension12;
    }
    setPosition(index) {
        this.position = index;
    }
}
exports.default = SubscriptionEcommerceProduct;
